import React, { useState, useRef } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';

import LoanList from '@C/Loans/RouteComponents/Parties/LoanList';
import SimpleReactValidator from 'simple-react-validator';
import { DateFilter } from '@C/Utils';

const Parties = () => {
  const [state, setState] = useState({
    party_name: '',
    mobile_no: '',
    editMode: false,
    updated: false,
    isSubmitting: false,
    time_stamp: dayjs().format('YYYY-MM-DD'),
    outstanding: 0,
  });
  const [_, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }),
  );

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setState({
      party_name: '',
      mobile_no: '',
      updated: false,
      editMode: false,
      isSubmitting: false,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate(Math.random());
      return;
    }
  };

  const { editMode } = state;

  return (
    <>
      <section className="widget full-width">
        <header>
          <h3> Add new loan party name </h3>
        </header>
        <main>
          <form className="inline">
            <div className="input-wrapper with-label ">
              <label>Date</label>
              {validator.current.message('date', state.time_stamp, 'required')}
              <DateFilter
                name="time_stamp"
                onChange={handleChange}
                value={state.time_stamp}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label>Party name </label>
              {validator.current.message(
                'party_name',
                state.party_name,
                'required',
              )}
              <input
                type="text"
                onChange={handleChange}
                value={state.party_name}
                name="party_name"
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Mobile no. </label>
              <input
                type="text"
                value={state.mobile_no}
                name="mobile_no"
                onChange={handleChange}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Outstanding </label>
              {validator.current.message(
                'outstanding',
                state.outstanding,
                'required|numeric',
              )}
              <input
                type="text"
                value={state.outstanding}
                name="outstanding"
                onChange={handleChange}
              />
            </div>
            <div className="form-actions">
              <button
                className="submit"
                disabled={state.isSubmitting}
                onClick={submitForm}
              >
                Submit
              </button>
              {editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </form>
        </main>
      </section>
      <LoanList
        onEdit={() => setState({ ...state, editMode: true })}
        key={state.updated}
      />
    </>
  );
};

export { Parties };
